import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Modal, Button } from 'components';
import { IModalAction } from 'models/modal';
import { showModal, closeModal } from 'modules/modal';
const { connect } = require('react-redux');
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
import { createLinkMenuItem } from 'redux/modules/menueditor';
import { getMenuItems, resetMenuItemsData } from 'redux/modules/menueditor';
import { IStore } from 'redux/IStore';
import { PortalSelectMenu } from 'components/FormControls';
import { IMenuEditor, IMenuEditorAction } from 'models/menueditor/menueditor';
import { MenuItemType } from 'models/enums/menuitemtype';
import { getFlatDataFromTree, TreeItem } from 'react-sortable-tree';
import { IMenuItem } from '../../../../../../models/menuitem/menuitem';
require('./style.css');

interface IState {
	selectedMenuItemId: string;
}

interface IProps {
	showHeaderCloseButton: boolean;
	menuEditor: IMenuEditor;
	menuItemType: MenuItemType;

	/* func props */
	getMenuItems?: (menuItemType: MenuItemType) => IMenuEditorAction;
	resetMenuItemsData?: () => IMenuEditorAction;
	createLinkMenuItem?: (title: string, link: string, menuItemType: MenuItemType, menuType: string) => IMenuEditorAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		menuEditor: state.menuEditor,
	}),
	(dispatch) => ({
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		getMenuItems: (menuItemType: MenuItemType) => dispatch(getMenuItems(menuItemType)),
		resetMenuItemsData: () => dispatch(resetMenuItemsData()),
		createLinkMenuItem: (title: string, link: string, menuItemType: MenuItemType, menuType: string) =>
			dispatch(createLinkMenuItem(title, link, menuItemType, menuType)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MenuTypeLink extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			selectedMenuItemId: null,
		};

		this.handleSaveAndCloseButtonClick = this.handleSaveAndCloseButtonClick.bind(this);
	}

	public componentDidMount() {
		this.props.getMenuItems(this.props.menuItemType);
	}

	public componentWillUnmount() {
		this.props.resetMenuItemsData();
	}

	private handleSaveAndCloseButtonClick() {
		if (this.state.selectedMenuItemId && this.state.selectedMenuItemId.length > 0) {
			const selected = this.props.menuEditor.menuItems.find((mi) => mi.id === this.state.selectedMenuItemId);
			this.props.createLinkMenuItem(selected.title, selected.code, this.props.menuItemType, selected.source);
		}
	}

	public render() {
		const { showHeaderCloseButton, closeModal, t, menuEditor } = this.props;

		const existingEditoritems: TreeItem<IMenuItem>[] = menuEditor.items;

		const flatData = getFlatDataFromTree({
			treeData: existingEditoritems,
			getNodeKey: ({ node }) => node.id,
			ignoreCollapsed: false,
		}).map(({ node, path }) => ({
			id: node.id,
			name: node.name,
			parent: path.length > 1 ? path[path.length - 2] : null,
		}));

		const menuItemsOptions = [];
		if (menuEditor && menuEditor.menuItems && menuEditor.menuItems.length > 0) {
			menuEditor.menuItems.forEach((menuItem: IMenuItem) => {
				if (
					menuItem.pageJObject &&
					menuItem.pageJObject.menuType === c.MENU_TYPE_PAGE &&
					flatData.findIndex((i) => i.id === menuItem.id) === -1
				) {
					menuItemsOptions.push({
						// admin can choose to add a link to existing real magazine or portal page = MENU_TYPE_PAGE
						key: menuItem.id,
						value: menuItem.title,
					});
				}
			});
		}

		return (
			<Modal
				title={'Select page'}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				modalClass="menuItemTypePage"
			>
				<PortalPageSection usage="admin">
					<div className="row">
						<div className="col-md-12">
							<PortalSelectMenu
								usage="admin"
								input={{
									id: 'menuItemId',
									onChange: (id: string) => {
										this.setState({ selectedMenuItemId: id });
									},
									value: this.state.selectedMenuItemId,
									name: 'menuItemId',
								}}
								items={menuItemsOptions}
							/>
						</div>
					</div>
				</PortalPageSection>
				<ButtonsSection>
					<div className="row">
						<div className="col-sm-12">
							<Button
								type="button"
								usage="admin"
								disabled={!this.state.selectedMenuItemId || this.state.selectedMenuItemId.length === 0}
								onClick={this.handleSaveAndCloseButtonClick}
							>
								{t('BSPortal_Common_SaveAndClose')}
							</Button>
						</div>
					</div>
				</ButtonsSection>
			</Modal>
		);
	}
}

export { MenuTypeLink };
